export const DiscoverEventName = "discover";
